/**
 * useElectronSettings
 * Hook to handle Electron's menu -> Settings interaction
 * Listens for the open-settings event from Electron's Preferences menu
 */

import { useEffect } from 'react';
import { onOpenSettings as electronOnOpenSettings } from '../utils/electronBridge';

/**
 * Hook that listens for Electron's open-settings event
 * @param onOpenSettings - Callback to open the settings modal
 */
export function useElectronSettings(onOpenSettings: () => void): void {
  useEffect(() => {
    // Subscribe via the bridge (no-op when not in Electron)
    const unsubscribe = electronOnOpenSettings(onOpenSettings);

    return () => {
      unsubscribe();
    };
  }, [onOpenSettings]);
}
